export default {

  get(env) {
    let userJson = window.localStorage.getItem(`current-user.${env}`)
    if (!userJson) { return }
    return JSON.parse(userJson)
  },

  set (env, user) {
    let smallUser = {
      first_name: user.first_name
    }
    window.localStorage.setItem(`current-user.${env}`, JSON.stringify(smallUser))
  }

}